import { validateMethod } from "../constants";

export const getUserInfo = apiResponse => {
  if (!apiResponse) {
    return null;
  }
  const { customerId, email, name, mobile } = apiResponse;
  return { customerId, email, name, mobile };
};

/**
 * Return the helpertext for form validation
 * @param  {Boolean} isValid
 * @return {String} helper text
 */
export const getValidationStatus = isValid => (isValid ? null : "error");

/**
 * Returns a validation object containing validation data
 * @param  {Object} fields Object containing fields to be validated
 * @return  {Object} Contains `isValid` which tells if are all fields valid
 * and contains `validation` object containing actual validation values
 */
export const validateInput = fields => {
  if (!fields) {
    return { isValid: false, validation: {} };
  }
  let isValid = true;
  const validation = {};
  Object.entries(fields).forEach(([key, value]) => {
    validation[key] = validateMethod[key](value);
    isValid = isValid && validation[key].isValid;
  });
  return { isValid, validation };
};

export function getHeaders(reCaptchaResponse, platform) {
  return {
    "Content-Type": "application/json",
    platformid: platform.id,
    CWK: "KYpLANI09l53DuSN7UVQ304Xnks=",
    SourceId: platform.id,
    IsWeb: true,
    "g-recaptcha-response": reCaptchaResponse,
  };
}
